// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconLayoutBoard, IconAdjustmentsHorizontal, IconWand } from '@tabler/icons';

// constant
const icons = {
    IconLayoutBoard,
    IconAdjustmentsHorizontal,
    IconWand
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const aiTools = {
    id: 'ai-tool',
    title: null,
    type: 'group',
    children: [
        // {
        //     id: 'project',
        //     title: <FormattedMessage id="project" />,
        //     type: 'item',
        //     url: '/project',
        //     icon: icons.IconLayoutBoard,
        //     breadcrumbs: false
        // },
        // {
        //     id: 'ai-smart-creator',
        //     title: <FormattedMessage id="ai-smart-creator" />,
        //     type: 'item',
        //     baseurl: '/ai-creator',
        //     icon: icons.IconWand,
        //     breadcrumbs: false
        // },
        {
            id: 'setting',
            title: <FormattedMessage id="setting" />,
            type: 'collapse',
            icon: icons.IconAdjustmentsHorizontal,
            children: [
                {
                    id: 'account-setting',
                    title: <FormattedMessage id="account-setting" />,
                    type: 'item',
                    baseurl: '/account-setting',
                    icon: null
                },
                {
                    id: 'workspace-setting',
                    title: <FormattedMessage id="workspace-setting" />,
                    type: 'item',
                    baseurl: '/workspace-setting',
                    icon: null
                },
                {
                    id: 'member',
                    title: <FormattedMessage id="member" />,
                    type: 'item',
                    baseurl: '/member',
                    icon: null
                },
                {
                    id: 'billing',
                    title: <FormattedMessage id="billing" />,
                    type: 'item',
                    baseurl: '/billing',
                    icon: null
                }
            ]
        }
    ]
};

export default aiTools;
